var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRideFiNotFoundLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 39H27V34.5H42V39ZM27 45V49.5H37.3238C38.1188 47.9025 39.0675 46.3988 40.1513 45H27ZM27 55.5V60H34.545C34.6313 58.4625 34.8488 56.9588 35.1825 55.5H27ZM88.6275 92.8725L76.2038 80.4488C72.1388 83.61 67.0388 85.5 61.5 85.5C48.2663 85.5 37.5 74.7338 37.5 61.5C37.5 48.2663 48.2663 37.5 61.5 37.5C74.7338 37.5 85.5 48.2663 85.5 61.5C85.5 67.0388 83.61 72.1388 80.4488 76.2038L92.8725 88.6275L88.6275 92.8725ZM61.5 79.5C71.4263 79.5 79.5 71.4263 79.5 61.5C79.5 51.5738 71.4263 43.5 61.5 43.5C51.5738 43.5 43.5 51.5738 43.5 61.5C43.5 71.4263 51.5738 79.5 61.5 79.5Z",
    fill: "url(#paint0_linear_53_3941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6138 86.1L79.8713 88.3575C78.3338 91.125 75.3825 93 72 93H24C19.0388 93 15 88.9613 15 84V12C15 7.03875 19.0388 3 24 3H60.6862L81 26.4412V42.855C80.07 41.88 79.065 40.9762 78 40.1512V30.0337L64.4888 30.0112C60.3525 30.0037 57 26.6475 57 22.5112V6H24C20.6925 6 18 8.6925 18 12V84C18 87.3075 20.6925 90 24 90H72C74.5687 90 76.7588 88.3725 77.6138 86.1ZM72.105 55.1362L67.8638 50.895L61.5 57.2588L55.1362 50.895L50.895 55.1362L57.2588 61.5L50.895 67.8638L55.1362 72.105L61.5 65.7412L67.8638 72.105L72.105 67.8638L65.7412 61.5L72.105 55.1362Z",
    fill: "url(#paint1_linear_53_3941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_3941",
    x1: 44.0466,
    y1: 79.0705,
    x2: 75.2164,
    y2: 49.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF3341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB91FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_3941",
    x1: 15,
    y1: 3,
    x2: 72.6226,
    y2: 98.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272135,
    stopColor: "#34263B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658079,
    stopColor: "#13172C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideFiNotFoundLight);
export default __webpack_public_path__ + "static/media/ride_fi_not_found_light.d05a4823d72641c02328a0fd3a38af70.svg";
export { ForwardRef as ReactComponent };